// src/utils/ProxyConfigProvider.ts
import {
  mergeModelConfigs
} from "../types/ModelConfigTypes.mjs";
var ProxyConfigProvider = class {
  _providers = /* @__PURE__ */ new Set();
  getModelConfig() {
    return mergeModelConfigs(this._providers);
  }
  registerModelConfigProvider(provider) {
    this._providers.add(provider);
    const unsubscribe = provider.subscribe?.(() => {
      this.notifySubscribers();
    });
    this.notifySubscribers();
    return () => {
      this._providers.delete(provider);
      unsubscribe?.();
      this.notifySubscribers();
    };
  }
  _subscribers = /* @__PURE__ */ new Set();
  notifySubscribers() {
    for (const callback of this._subscribers) callback();
  }
  subscribe(callback) {
    this._subscribers.add(callback);
    return () => this._subscribers.delete(callback);
  }
};
export {
  ProxyConfigProvider
};
//# sourceMappingURL=ProxyConfigProvider.mjs.map